/**
 * TagSelector — 通用标签选择器组件
 */
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface TagSelectorProps {
  options: string[];
  selected: string[];
  onChange: (tags: string[]) => void;
  max: number;
}

const TagSelector: React.FC<TagSelectorProps> = ({ options, selected, onChange, max }) => {
  const [expanded, setExpanded] = useState(false);
  const displayOptions = expanded ? options : options.slice(0, 12);

  const toggle = (tag: string) => {
    if (selected.includes(tag)) {
      onChange(selected.filter(t => t !== tag));
    } else if (selected.length < max) {
      onChange([...selected, tag]);
    }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-1.5">
        {displayOptions.map(tag => (
          <button
            key={tag}
            onClick={() => toggle(tag)}
            className={`px-2 py-0.5 rounded-full text-xs transition-colors ${
              selected.includes(tag)
                ? 'bg-coral-500 text-white'
                : selected.length >= max
                  ? 'bg-gray-50 text-gray-300 cursor-not-allowed'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
            }`}
            disabled={!selected.includes(tag) && selected.length >= max}
          >
            {tag}
          </button>
        ))}
      </div>
      {options.length > 12 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-1.5 text-xs text-[#9CA3AF] hover:text-coral-500 flex items-center gap-0.5"
        >
          {expanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
          {expanded ? '收起' : `展开全部 (${options.length})`}
        </button>
      )}
    </div>
  );
};

export default TagSelector;
